import React from "react";
import { Container, Typography, Box, Paper, Divider } from "@mui/material";
import { Helmet } from "react-helmet-async";
import AnalyticsTracker from "../GASetup/AnalyticsTracker";
import {
  cardOutline,
  fonts,
  headingFonts,
  semiBoldFonts,
} from "../../Styles/Styles";

const Disclaimer = () => {
  return (
    <Container
      maxWidth="md"
      sx={{
        mt: 5,
        mb: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Helmet>
        <title>Disclaimer - Listed.ky</title>
        <meta name="description" content="Disclaimer - Listed.ky" />
      </Helmet>
      <AnalyticsTracker />

      {/* Page Title */}
      <Typography
        variant="h3"
        sx={{
          mb: 2,
          ...semiBoldFonts,
          letterSpacing: 2,
          color: "var(--primary-color)",
          textTransform: "uppercase",
          position: "relative",
          display: "inline-block",
          paddingBottom: "8px",
          "&::after": {
            content: '""',
            width: "80px",
            height: "4px",
            backgroundColor: "var(--primary-color)",
            position: "absolute",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
          },
        }}
      >
        Disclaimer
      </Typography>

      {/* Disclaimer Card */}
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          borderRadius: "12px",
          backgroundColor: "white",
          ...cardOutline,
        }}
      >
        {[
          {
            title: "1. General Information",
            content:
              "The information provided by Listed.ky is for general informational purposes only. All listings and advertisements on our platform are submitted by users and are not verified by Listed.ky. While we strive to maintain accurate and up-to-date information, we cannot guarantee the accuracy, completeness, or reliability of any content, including listings for sale.",
          },
          {
            title: "2. No Liability",
            content:
              "Listed.ky is not responsible for any transactions that occur between buyers and sellers, including:",
            list: [
              "Failure to deliver products or services.",
              "Misrepresentation of listings.",
              "Issues arising from communications between users.",
            ],
            extra:
              "Any disputes or claims should be resolved directly between the involved parties.",
          },
          {
            title: "3. User Responsibility",
            content:
              "It is the responsibility of users to conduct their own due diligence when engaging with other members of the community. We encourage users to verify the authenticity of sellers and the legitimacy of listings.",
          },
          {
            title: "4. Content Review",
            content:
              "Listed.ky reserves the right to review and remove any content that violates our Terms of Service or is deemed inappropriate. However, we do not undertake any obligation to monitor user-generated content.",
          },
          {
            title: "5. External Links",
            content:
              "Our platform may contain links to third-party websites. Listed.ky is not responsible for the content, privacy policies, or practices of any external sites. Your use of such websites is at your own risk.",
          },
          {
            title: "6. No Endorsement",
            content:
              "The presence of any advertisement or listing on Listed.ky does not imply endorsement or recommendation by Listed.ky. We make no representations about the quality, safety, or legality of any item listed for sale.",
          },
          {
            title: "7. Governing Law",
            content:
              "This disclaimer is governed by the laws of the Cayman Islands. Any disputes arising from this disclaimer or your use of Listed.ky shall be resolved in accordance with the applicable laws of the Cayman Islands.",
          },
          {
            title: "8. Agreement",
            content:
              "By using our services, you agree to these terms and acknowledge that you have read and understood this disclaimer. If you do not agree, please refrain from using Listed.ky.",
          },
        ].map((section, index) => (
          <Box key={index} sx={{ mb: 3 }}>
            <Typography
              variant="h6"
              sx={{
                ...headingFonts,
                color: "var(--primary-color)",
              }}
            >
              {section.title}
            </Typography>
            <Typography
              paragraph
              sx={{
                ...fonts,
                color: "text.secondary",
                mt: 1,
              }}
            >
              {section.content}
            </Typography>
            {section.list && (
              <ul>
                {section.list.map((item, idx) => (
                  <li key={idx} style={{ ...fonts, color: "rgb(0 0 0 / 60%)" }}>
                    {item}
                  </li>
                ))}
              </ul>
            )}
            {section.extra && (
              <Typography
                sx={{
                  ...fonts,
                  fontStyle: "italic",
                  color: "text.secondary",
                  mt: 1,
                }}
              >
                {section.extra}
              </Typography>
            )}
            {index !== 7 && (
              <Divider sx={{ my: 3, borderColor: "rgba(0, 0, 0, 0.1)" }} />
            )}
          </Box>
        ))}
      </Paper>
    </Container>
  );
};

export default Disclaimer;
